// extracted by mini-css-extract-plugin
export default {"cls1":"FeedbackModal-cls1_noq","cls2":"FeedbackModal-cls2_Lfn FeedbackModal-cls1_noq"};